module.exports = __webpack_public_path__ + "static/media/filled_bar_tall.67432d01.svg";